import timezones from 'google-timezones-json';
import includes from 'lodash/includes';
import pick from 'lodash/pick';

// platform-specific timezone getting/guessing
import getCurrentTimezone from 'lib/getTimezone';

const usTimezones = [
  'America/Puerto_Rico',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
];

const isUsTimezone = timezone => includes(usTimezones, timezone);

const getTimezoneOptions = () => {
  const currentTimezone = getCurrentTimezone();
  return currentTimezone && isUsTimezone(currentTimezone)
    ? pick(timezones, usTimezones)
    : timezones;
};

export {
  getCurrentTimezone as getTimezone,
  getTimezoneOptions,
  isUsTimezone,
};
